'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002e$002dString$002dParsers$0024 from "./scala.collection.-String-Parsers$.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dRight from "./scala.util.-Right.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$() {
}
export { $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ as $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ };
$p = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$() {
}
export { $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ as $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ };
$h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$.prototype = $p;
$p.jx = (function(str) {
  var this$3 = ($j_java$002elang$002e$002dObject.$m_sc_StringOps$(), $j_scala$002ecollection$002e$002dString$002dParsers$0024.$m_sc_StringParsers$().Ch(str));
  return (this$3.k() ? new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left("Not a int") : new $j_scala$002eutil$002e$002dRight.$c_s_util_Right(this$3.C()));
});
var $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$, "dev.cheleb.scalamigen.Validator$given_Validator_Int$", ({
  jl: 1,
  bn: 1
}));
export { $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ as $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ };
var $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$;
function $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$() {
  if ((!$n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$)) {
    $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ = new $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$();
  }
  return $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$;
}
export { $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ as $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fInt$ };
